import React, { useEffect, useState } from 'react'
import { makeStyles, useTheme } from '@seahorse/ui'
import { TextField, Button } from '@seahorse/ui'
import { queryEmgpt } from '../../Utils/Utils'
import { StackBarChart, Legend, BarChartOptions, LineChart, LineChartOptions } from '@seahorse/charts'
import { fetchNews, fetchChartData } from '../../Utils/Utils'
import { Dropdown } from '@seahorse/ui'
import { DateRangePicker } from '@seahorse/ui'


const mockGraphData = [
    {
        "x": "0/22",
        "y": 0.1,
        "y1": 2
    },
    {
        "x": "1/22",
        "y": 0.4,
        "y1": 0
    },
    {
        "x": "2/22",
        "y": 0.5,
        "y1": 0
    },
    {
        "x": "3/22",
        "y": 0.2,
        "y1": 0
    },
    {
        "x": "4/22",
        "y": -0.1
    },
    {
        "x": "5/22",
        "y": -0.2,
        "y1": 0
    },
    {
        "x": "6/22",
        "y": 0.3,
        "y1": 0
    },
    {
        "x": "7/22",
        "y": 0.4,
        "y1": 0
    },
    {
        "x": "8/22",
        "y": 0.6,
        "y1": 0
    },
    {
        "x": "9/22",
        "y": 0.5,
        "y1": 0
    },
    {
        "x": "10/22",
        "y": 0.6,
        "y1": -0.2
    },
    {
        "x": "11/22",
        "y": 0.8,
        "y1": 0.6
    },
    {
        "x": "12/22",
        "y": -0.1,
        "y1": 1
    }
]

const DropdownItem = [
    {
        "label": "Indian PM",
        "value": "Indian PM"
    },
    {
        "label": "Indian Rupee",
        "value": "Indian Rupee"
    },
    {
        "label": "Indian National Congress",
        "value": "Indian National Congress"
    },
    {
        "label": "PNOTES",
        "value": "PNOTES"
    },
    {
        "label": "RBI",
        "value": "RBI"
    },
    {
        "label": "Monsoon",
        "value": "Monsoon"
    },
    {
        "label": "Interest Rate",
        "value": "Interest Rate"
    },
    {
        "label": "Derivatives Market",
        "value": "Derivatives Market"
    },
    {
        "label": "Rahul Gandhi",
        "value": "Rahul Gandhi"
    },
    {
        "label": "FDI",
        "value": "FDI"
    },
    {
        "label": "FPI",
        "value": "FPI"
    },
    {
        "label": "IPO",
        "value": "IPO"
    },
    {
        "label": "Imports",
        "value": "Imports"
    },
    {
        "label": "GDP",
        "value": "GDP"
    },
    {
        "label": "Foreign Exchange Reserves",
        "value": "Foreign Exchange Reserves"
    },
    {
        "label": "Stock Market",
        "value": "Stock Market"
    },
    {
        "label": "Budget",
        "value": "Budget"
    },
    {
        "label": "Economy",
        "value": "Economy"
    },
    {
        "label": "Export Restrictions",
        "value": "Export Restrictions"
    },
    {
        "label": "Indian Opposition Party",
        "value": "Indian Opposition Party"
    },
    {
        "label": "Modi",
        "value": "Bharatiya Janata Party"
    },
    {
        "label": "ETCD",
        "value": "ETCD"
    },
    {
        "label": "Exports",
        "value": "Exports"
    },
    {
        "label": "Debt",
        "value": "Debt"
    },
    {
        "label": "Bond Index",
        "value": "Bond Index"
    },
    {
        "label": "Inflation",
        "value": "Inflation"
    },
    {
        "label": "P Chidambaram",
        "value": "P Chidambaram"
    },
    {
        "label": "Deficit",
        "value": "Deficit"
    },
    {
        "label": "Bond Market",
        "value": "Bond Market"
    }
]

const ChartTileComponent: React.FunctionComponent = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const theme = useTheme()
    const [chartData, setChartData] = useState(mockGraphData)
    const [filter1, setFilter1] = useState([])
    const [selectedFilterOption, setSelectedFilterOption] = useState({
        selectedCountries: [],
        selectedCompanies: [],
        selectedIsin: [],
    })

    const colors = {
        Pending: theme.globallink.colors.DataTurquoise[500],
        Ineligible: theme.globallink.colors.DataOrange[500],
        Cleared: theme.globallink.colors.DataPurple[500],
        Rejected: theme.globallink.colors.DataAmber[600],
        Dark: theme.globallink.colors.Grey[1100],
        Light: theme.globallink.colors.White[500],
        question: theme.globallink.colors.Blue[500],
        answer: theme.globallink.colors.White[500],
    }
    const useStyles = makeStyles({
        container: {
            width: '100%',
            height: '95%',
            padding: '10px',
        },
        container1: {
            overflow: 'auto',
            height: '90%',
            width: '100%',
            backgroundColor: colors.Dark,
            padding: '10px',
        },
        dropdownContainer: {
            width: '100%',
            padding: '10px',
            display: 'flex',
            flexDirection: 'row',
        }
        
    })

    const classes = useStyles()

    const [selectedCompany, setSelectedCompany] = useState("Bharatiya Janata Party")
    useEffect(() => {
        fetchChartData(setChartData, setFilter1)
    }, [])
    const optionsLine: LineChartOptions = {
        showGradient: false,
        strokeWidth: 3,

        lineColor: "#43CFE6",
        chartName: "Risk Analysis Chart",

        xAxis: {
            dataKey: "x",

            "tickSize": 2,
            "maxTickCount": 7,
            "tickLineColor": "#43CFE6",
            "tickLineWidth": 2,
            "max": 10,
            "min": 0
        },
        yAxis: {
            dataKey: selectedCompany,
        }

    }

    
    return (
        <>
            <div className={classes.container}>
                <div className={classes.dropdownContainer}>
                    <DateRangePicker locale={"en"} className='w-25  p-2' filterDate={(date: Date) => (date >= new Date("2017-01-01"))} minDate={new Date("2017-01-01")} maxDate={new Date()} monthsShown={2} excludeDates={[new Date()]} />
                    <Dropdown items={DropdownItem} onChange={y => setSelectedCompany(y)} value={selectedCompany} className='w-25 p-2' />

                </div>
                
                <div className={classes.container1}>
                    <LineChart data={chartData} options={optionsLine} />
                </div>
            </div>
        </>
    ) 
}

export default ChartTileComponent
